import { render } from "./rancher-vcluster.vue?vue&type=template&id=35bfe642&scoped=true"
import script from "./rancher-vcluster.vue?vue&type=script&lang=js"
export * from "./rancher-vcluster.vue?vue&type=script&lang=js"

import "./rancher-vcluster.vue?vue&type=style&index=0&id=35bfe642&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bfe642"]])

export default __exports__